import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Box,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import {
  CumulativeClosedWonChart,
  PipelineByStageChart,
  ForecastAccuracyChart,
} from "../DealProgressionCharts";
import * as d3 from "d3";
import { updatedScheme10 } from "../../../util/chartColorScheme";

const DealProgressionPaper = ({
  classes,
  paperTitle,
  dealProgressionData,
  isDealProgressionLoading,
  currencySymbol,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            {/* Deal Progression and Closures */}
            {dealProgressionData?.title}
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        {isDealProgressionLoading ? (
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={300}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={280}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={280}
                width="100%"
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {/* Chart 1: Cumulative Closed Won by Month */}
            <Grid item xs={12} md={12}>
              <Card className={classes.chartCard}>
                <CardContent>
                  <div className={classes.chartContainer}>
                    <CumulativeClosedWonChart
                      data={dealProgressionData?.cumulativeClosedWon}
                      fiscalYear={dealProgressionData?.fiscalYear}
                      fixedHeight={350}
                      currencySymbol={currencySymbol}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>

            {/* Chart 2: Pipeline percent by stage */}
            <Grid item xs={12} md={6}>
              <Card className={classes.chartCard}>
                <CardContent>
                  <div className={classes.chartContainer}>
                    <PipelineByStageChart
                      data={dealProgressionData?.pipelineByStage}
                      currentFiscalQuarter={
                        dealProgressionData?.currentFiscalQuarter
                      }
                      stageCategories={dealProgressionData?.stageCategories}
                    />
                  </div>
                  {/* Legend for stacked bar - Dynamic */}
                  <Box mt={2}>
                    <div className={classes.legend}>
                      {(() => {
                        const colorScale = d3.scaleOrdinal(updatedScheme10);
                        return dealProgressionData?.stageCategories?.map(
                          (category, index) => (
                            <div key={category} className={classes.legendItem}>
                              <div
                                className={classes.legendBox}
                                style={{
                                  backgroundColor: colorScale(category),
                                }}
                              />
                              <Typography variant="body2">
                                {category}
                              </Typography>
                            </div>
                          ),
                        );
                      })()}
                    </div>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Chart 3: Forecast Accuracy */}
            <Grid item xs={12} md={6}>
              <Card className={classes.chartCard}>
                <CardContent>
                  <div className={classes.chartContainer}>
                    <ForecastAccuracyChart
                      data={dealProgressionData?.forecastAccuracy}
                      target={dealProgressionData?.forecastAccuracyTarget}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Paper>
    </Grid>
  );
};

export default DealProgressionPaper;
